import { render, staticRenderFns } from "./NewPaymentsPayoneerModule.vue?vue&type=template&id=51c67af6"
import script from "./NewPaymentsPayoneerModule.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports